module.exports = __webpack_public_path__ + "img/document-signature-empty.25ab9335.png";